import React, { FC } from "react";

import classnames from "classnames";

import { DropdownButton, type DropdownButtonProps } from "Cobalt/Dropdown";

import DropdownSubmenuFilter from "./DropdownSubmenuFilter";

export interface DropdownMultiSelectFilterProps extends DropdownButtonProps {
  filterConfig: any;
  onChangeFilter: (arg0: string, arg1: any) => void;
  options: Array<any>;
  filterKey: string;
  menuTitle: string;
  defaultOptions?: Array<any>;
  defaultSelect?: boolean;
  className?: string;
}

const DropdownMultiSelectFilter: FC<DropdownMultiSelectFilterProps> = ({
  filterConfig,
  options,
  filterKey,
  menuTitle,
  defaultOptions,
  defaultSelect,
  onChangeFilter,
  className,
  size,
  keepOpenOnSelect = true,
}) => {
  let selectedOptions = null;
  const listOptions = options.map((option) => option.value);

  const isMinMaxFilter = (listOptions: Array<Record<string, any>>) => {
    return listOptions.length > 0 && (Object.keys(listOptions[0]).includes("max") || Object.keys(listOptions[0]).includes("min"));
  };
  const filterType = isMinMaxFilter(listOptions) ? "ranges" : "include";

  selectedOptions = (filterConfig[filterKey] ? filterConfig[filterKey][filterType] : null) || defaultOptions;

  const defaultFilters = selectedOptions && (selectedOptions.length == listOptions.length || selectedOptions.length == 0);

  const isSelected = !(defaultSelect && defaultFilters);

  return (
    <div className={className}>
      <DropdownButton
        title={menuTitle}
        size={size}
        color={isSelected ? "secondary" : "white"}
        className={classnames("block border-solid border-transparent", {
          "border-blue hover:border-blue": isSelected,
        })}
        dropdownClassName="rounded-xl"
        type="filter"
        p={3}
        keepOpenOnSelect={keepOpenOnSelect}
        dropdownPosition="right"
      >
        <DropdownSubmenuFilter
          filterConfig={filterConfig}
          options={options}
          filterKey={filterKey}
          menuTitle={menuTitle}
          defaultOptions={defaultOptions}
          defaultSelect={defaultSelect}
          onChangeFilter={onChangeFilter}
          filterType={filterType}
        />
      </DropdownButton>
    </div>
  );
};

export default DropdownMultiSelectFilter;
